import {useCallback, useRef} from 'react';
import {t} from 'i18next';
import {toast} from 'react-toastify';
import {v4 as uuid} from 'uuid';
import {ExportTypes} from '../../../incase-domain/common/exportTypes';
import {IElement} from '../../../incase-domain/elements';
import {ISlide} from '../../../incase-domain/slide';
import {importElementFileContentSchema} from '../../../incase-domain/validators/elements/importElement';
import {FileResult} from '../BaseFileLoader';

export default function useNblFileReader(onLoad: (element: IElement[]) => void, getSlide: () => ISlide): (files: FileResult[]) => void {
    const onLoadRef = useRef(onLoad);
    onLoadRef.current = onLoad;

    return useCallback(
        async (files: FileResult[]) => {
            const slide = getSlide();
            Promise.all<IElement | null>(
                files.map(({reader}) => {
                    return new Promise((resolve) => {
                        try {
                            const contents = reader.result as string;
                            const parsedContents: {data: IElement; type: ExportTypes} = JSON.parse(contents);
                            importElementFileContentSchema.parse(parsedContents);
                            const newId = uuid();
                            const newElement = {
                                ...parsedContents.data,
                                slideId: slide._id,
                                id: `${slide._id}-${newId}`,
                                keyIndex: `slide-${slide._id}-element-${newId || slide.elements.length}-inner`,
                                elementIndex: slide.elements.length,
                            };
                            resolve(newElement);
                        } catch (e) {
                            toast.error(t('contextMenuSlide.errors.importElementWrongTypeDescription'), {toastId: 'nbl-import-pres-error'});
                            resolve(null);
                        }
                    });
                })
            ).then((results) => {
                const validElements = results.filter((element): element is IElement => !!element);
                onLoadRef.current(validElements);
            });
        },
        [getSlide]
    );
}
